// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.
export const APPROVAL_EXPIRY_DAYS_DEFAULT = 7;
export const APPROVAL_EXPIRY_DAYS_MIN = 1;
export const APPROVAL_EXPIRY_DAYS_MAX = 90;
/** The three enforcement levels, in escalation order. The runtime source. */
export const MFA_ENFORCEMENT_LEVELS = [
    'optional',
    'admin_required',
    'all_required',
];
//# sourceMappingURL=org-settings.js.map